import { createAction } from 'redux-actions';
import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchLinkedFastags } from '../services';
import {
  GET_LINKED_FASTAG_FAILURE,
  GET_LINKED_FASTAG_REQUEST,
  GET_LINKED_FASTAG_RESET,
  GET_LINKED_FASTAG_START,
  GET_LINKED_FASTAG_SUCCESS,
  UPDATE_STATUS_POPUP,
  UPDATE_USER_VEHICLE,
  UPDATE_USER_VEHICLE_FASTAGS,
} from './type';

export const getLinkedFastagStart = createAction(GET_LINKED_FASTAG_START);
export const getLinkedFastagRequest = createAction(GET_LINKED_FASTAG_REQUEST);
export const getLinkedFastagSuccess = createAction(GET_LINKED_FASTAG_SUCCESS);
export const getLinkedFastagFailure = createAction(GET_LINKED_FASTAG_FAILURE);
export const getLinkedFastagReset = createAction(GET_LINKED_FASTAG_RESET);

export const updateUserVehicleFastags = createAction(
  UPDATE_USER_VEHICLE_FASTAGS
);
export const updateUserVehicle = createAction(UPDATE_USER_VEHICLE);

export const updateStatusPopup = createAction(UPDATE_STATUS_POPUP);

function* getLinkedFastag() {
  yield put(getLinkedFastagRequest());
  try {
    const { response, error } = yield call(fetchLinkedFastags);
    if (response) yield put(getLinkedFastagSuccess(response));
    if (error) yield put(getLinkedFastagFailure(error));
  } catch (error) {
    yield put(getLinkedFastagFailure(error));
  }
}

export function* watchFastag() {
  yield takeEvery(GET_LINKED_FASTAG_START, getLinkedFastag);
}
